import axios from 'axios'

import { baseApi } from '../consts/consts'

export const uploadFileWithProgress = async (
  file: File,
  onProgress: (percent: number) => void
): Promise<any> => {
  const formData = new FormData()
  formData.append('file', file)

  return axios
    .post(`${baseApi}/table/upload_file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total) {
          const percentComplete = Math.round((progressEvent.loaded / progressEvent.total) * 100)
          onProgress(percentComplete)
        }
      },
    })
    .then((response) => response.data)
}
